import { Form } from 'antd';
import React from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { translate } from 'react-i18next';
import ResponsiveTable from './ResponsiveTable';
import Table from 'antd/lib/table';
import { formatDate, currencyFormatter } from '../../utils/helpers';

const Column = Table.Column;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },

};


const renderScore = (score) => {

    let scoreValue = Number(score)

    if (scoreValue <= 2){
        return {
            children: <span style={{color: 'green'}}>{score}</span>
        }
    }
    else if (scoreValue > 2 && scoreValue < 4){
        return {
            children: <span style={{color: 'orange'}}>{score}</span>
        }
    }
    else {
        return {
            children: <span style={{color: 'red'}}>{score}</span>
        }
    }

}


const APVList = ({ data, token, t}) => {

    const isObject = (value) => typeof value === "object" && value === null

    if(isObject(data)){
        return(
        <span>APV nedostupné v čase žiadosti</span>
        )
    }
    
            
    if (data.client === 'ANO'){
        return (
            <section>
                <Row>
                    <Col xs={14} sm={6}>
                        <Form.Item {...formItemLayout} style={{marginBottom: 0+'px'}} label={t('Meno klienta')}>
                            <span style={{marginBottom: 12+'px'}}>{`${data.firstname} ${data.lastname}`}</span>
                        </Form.Item>
                        <Form.Item {...formItemLayout} style={{marginBottom: 0+'px'}} label={t('Priemerná známka')}>
                            <span style={{marginBottom: 12+'px'}}>{renderScore(data.averageScore).children}</span>
                        </Form.Item>
                    </Col> 
                    <Col xs={14} sm={6}>
                        <h4>Počty pôžičiek klienta</h4>
                        <Form.Item {...formItemLayout} style={{marginBottom: 0+'px'}} label={t('Zaplatené pôžičky')}>
                            <span style={{marginBottom: 12+'px'}}>{`${data.paidLoans} `}</span>
                        </Form.Item>
                        <Form.Item {...formItemLayout} style={{marginBottom: 0+'px'}} label={t('Nezaplatené pôžičky')}>
                            <span style={{marginBottom: 12+'px'}}>{`${data.unPaidLoans}`}</span>
                        </Form.Item>   
                    </Col>
                </Row>
                <ResponsiveTable dataSource={data.loans}>
                    <Column 
                        title={t('Stav')}
                        dataIndex='state'
                        key='state'
                        render={value => value === 'Nesplatená' ? <span style={{color:'red'}}>{`${value}`}</span> : value}
                    />
                    <Column
                        title={t('Známka')}
                        dataIndex='score'
                        key='score'
                        render={value => renderScore(value)}
                    />
                    <Column 
                        title={t('Stav zmluvy')}
                        dataIndex='contractState'
                        key='contractState'
                        render={value => value}
                    />
                    <Column 
                        title={t('Dátum vytvorenia')}
                        dataIndex='dateCreated'
                        key='dateCreated'
                        render={value => formatDate(new Date(value))}
                    />
                    <Column 
                        title={t('Dátum zmeny stavu')}
                        dataIndex='dateOfUpdatedState'
                        key='dateOfUpdatedState'
                        render={value => formatDate(new Date(value))}
                    />
                    <Column
                        title={t('Istina')}
                        dataIndex='amountLoaned'
                        key='amountLoaned'
                        render={value => currencyFormatter(value)}
                    />
                    <Column 
                        title={t('Dlžná suma')}
                        dataIndex="amountToRepay"
                        key="amountToRepay"
                        render={value => value != null ? currencyFormatter(value) : ''}
                    />
                </ResponsiveTable>
            </section>
        )

    }
    else {
        return (
          <span>Klient bez pôžičky</span>
        )
    }            
}



export default translate()(APVList)


// WEBPACK FOOTER //
// ./src/common/components/data-display/APVList.js